import type { ReactNode } from 'react';
import { ChartErrorBoundary } from '../ChartErrorBoundary.js';

interface Props {
  readonly sectionName: string;
  readonly children: ReactNode;
}

/** Wraps chart content in ChartErrorBoundary + an-card (Appendix J). */
export function AnChartSection({ sectionName, children }: Props): JSX.Element {
  return (
    <ChartErrorBoundary sectionName={sectionName}>
      <div className="an-card">{children}</div>
    </ChartErrorBoundary>
  );
}
